import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  disable365IntegrationError,
  disable365IntegrationSuccess,
  disablePowershellIntegrationError,
  disablePowershellIntegrationSuccess,
  getStatus365Error,
  getStatus365Success,
  getStatusPowershellError,
  getStatusPowershellSuccess,
} from './actions'
import {
  DISABLE_365_INTEGRATION_REQUEST_ASYNC,
  DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC,
  STATUS_365_REQUEST_ASYNC,
  STATUS_POWERSHELL_REQUEST_ASYNC,
} from './constants'

const get365StatusEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      STATUS_365_REQUEST_ASYNC.INITIATE,
      DISABLE_365_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getO365Status(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getStatus365Success(response))
        .catch((error) => Observable.of(epicsErrorHandler(getStatus365Error, error)))
    )

const getPowershellStatusEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    // only if 365 success?
    .ofType(
      STATUS_POWERSHELL_REQUEST_ASYNC.INITIATE,
      DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DISABLE_365_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getPowershellStatus(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getStatusPowershellSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getStatusPowershellError, error)))
    )

const disable365IntegrationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DISABLE_365_INTEGRATION_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .disableO365Integration(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => disable365IntegrationSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(disable365IntegrationError, error)))
  )

const disablePowershellIntegrationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DISABLE_POWERSHELL_INTEGRATION_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .disablePowershellIntegration(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => disablePowershellIntegrationSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(disablePowershellIntegrationError, error)))
  )

export default combineEpics(
  get365StatusEpic,
  disable365IntegrationEpic,
  getPowershellStatusEpic,
  disablePowershellIntegrationEpic
)
